// import contrast from 'get-contrast';

import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const CancelIcon = ({
  marginLeft,
  marginRight,
  color = 'foraBlue',
  title,
  width = 13,
  containerSize,
}: DefaultIconProps) => {
  // TODO: fix module get-contrast or find alternative  - Task#67934
  // const accessibleColor = contrast.ratio(getColor('white'), getSemanticTextColor(color)) > 2 ? 'white' : 'foraBlue';

  return (
    <DefaultIconWrapper
      marginLeft={marginLeft}
      marginRight={marginRight}
      containerSize={containerSize}
      width={width}
      title={title}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13" version="1.1">
        <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="icons-original/close-original">
            <g id="Group">
              <circle id="back" fill={getSemanticTextColor(color)} cx="6.5" cy="6.5" r="6.5" />
              <path
                d="M9.02891967,3.26397355 L9.73602645,3.97108033 L7.20697355,6.49997355 L9.73602645,9.02891967 L9.02891967,9.73602645 L6.49997355,7.20697355 L3.97108033,9.73602645 L3.26397355,9.02891967 L5.79197355,6.49997355 L3.26397355,3.97108033 L3.97108033,3.26397355 L6.49997355,5.79197355 L9.02891967,3.26397355 Z"
                id="line"
                // TODO: change back to accessibleColor when get-contrast is fixed - Task#67934
                fill={getSemanticTextColor('white')}
              />
            </g>
          </g>
        </g>
      </svg>
    </DefaultIconWrapper>
  );
};
